import { render, staticRenderFns } from "./BaseLogo.vue?vue&type=template&id=4bca4fd8&"
import script from "./BaseLogo.vue?vue&type=script&lang=js&"
export * from "./BaseLogo.vue?vue&type=script&lang=js&"
import style0 from "./BaseLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports